<template>
    <div class="login">
        <p class="welcome-text">
            欢迎您注册成为本站用户，享受高级资源服务！
        </p>
        <div class="login-form">

            <!-- form表单元素 -->
            <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" :rules="rules" status-icon
                label-width="100px" class="demo-ruleForm">
                <el-form-item label="用户名：" prop="user">
                    <el-input type="text" v-model="dynamicValidateForm.user" placeholder="汉字/字母/数字及其组合均可"></el-input>
                </el-form-item>
                <el-form-item label="邮箱：" prop="email">
                    <el-input type="email" v-model="dynamicValidateForm.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="pwd">
                    <el-input type="password" v-model="dynamicValidateForm.pwd" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label="重复密码：" prop="pwd2">
                    <el-input type="password" v-model="dynamicValidateForm.pwd2" placeholder="确认密码"></el-input>
                </el-form-item>
                <el-form-item label="专业方向：" prop="specialty">
                    <el-input type="text" v-model="dynamicValidateForm.specialty" placeholder="正确填写，更好为你服务"></el-input>
                </el-form-item>
                <el-form-item label="单位名/姓名:" prop="name">
                    <el-input type="text" v-model="dynamicValidateForm.name" placeholder="单位名称或您下姓名、 昵称均可"></el-input>
                </el-form-item>
                <el-form-item label="手机号码：" prop="phone">
                    <el-input type="text" v-model.number="dynamicValidateForm.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item label="QQ号码：" prop="qq">
                    <el-input type="text" v-model.number="dynamicValidateForm.qq" placeholder="填写常用QQ方便联系"></el-input>
                </el-form-item>

                <el-form-item>
                    <span class="btn" @click="$router.push({path:'/login'})">返回登录</span>
                    <span class="btn" @click="$refs['dynamicValidateForm'].resetFields()">重置</span>
                    <span class="btn" @click="submitForm('dynamicValidateForm')">
                        <i v-if="request">提交注册</i>
                        <i class="el-icon-loading lod" v-else></i>
                    </span>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    // 验证密码规则
    function test(s) {
        if (/^(\d)\1+$/.test(s)) return false; // 全一样
        var str = s.replace(/\d/g, function ($0, pos) {
            return parseInt($0) - pos;
        });
        if (/^(\d)\1+$/.test(str)) return false; // 顺增
        str = s.replace(/\d/g, function ($0, pos) {
            return parseInt($0) + pos;
        });
        if (/^(\d)\1+$/.test(str)) return false; // 顺减
        return true;
    }

        export default {
            data() {
                // 验证用户名
                var user_verify = (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入用户名'));
                    } else {
                        callback();
                    };
                }
                // 验证密码
                var pwd_verify = (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入密码'));
                    } else if (!test(value)) {
                        callback(new Error('密码过于简单'));
                    } else {
                        callback();
                    };
                }
                // 验证重复输入密码
                var pwd2_verify = (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入密码'));
                    } else if (value != this.dynamicValidateForm.pwd) {
                        callback(new Error('两次输入密码不一致!'));
                    } else {
                        callback();
                    };
                }
                return {
                    request: true,
                    // 表单数据
                    dynamicValidateForm: {
                        user: '',
                        email: '',
                        pwd: '',
                        pwd2: '',
                        specialty: '',
                        name: '',
                        phone: '',
                        qq: '',
                    },
                    rules: {
                        user: [
                            { min: 6, max: 16, message: '用户名长度在6到16个字符', trigger: 'blur' },
                            { required: true, validator: user_verify, trigger: 'blur' },
                        ],
                        email: [
                            { required: true, type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                        ],
                        pwd: [
                            { min: 8, max: 16, message: '密码长度在8到16个字符', trigger: 'blur' },
                            { required: true, validator: pwd_verify, trigger: 'blur' },
                        ],
                        pwd2: [
                            { min: 8, max: 16, message: '密码长度在8到16个字符', trigger: 'blur' },
                            { required: true, validator: pwd2_verify, trigger: 'blur' },
                        ],
                        specialty: [
                            { min: 2, max: 20, message: '专业方向长度在2到20个字符', trigger: 'blur' },
                            { required: true, message: '专业方向不能为空', trigger: 'blur' }
                        ]
                    }
                };
            },
            methods: {
                // 提交表单
                submitForm(formName) {
                    this.request = false;
                    this.request = true;
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // 检验通过后发起请求
                            let param = new URLSearchParams();
                            param.append("login_name", this.dynamicValidateForm.user);
                            param.append("pwd", this.dynamicValidateForm.pwd);
                            param.append("email", this.dynamicValidateForm.email);
                            param.append("major", this.dynamicValidateForm.specialty);
                            param.append("user_name", this.dynamicValidateForm.name);
                            param.append("qq", this.dynamicValidateForm.qq);
                            param.append("phone", this.dynamicValidateForm.phone);
                            this.$http.getRegister(param).then(response => {
                                if (response.code == 200) {
                                    this.$message({
                                        message: '注册成功消息',
                                        type: 'success'
                                    });
                                    this.$refs['dynamicValidateForm'].resetFields()
                                }else{
                                    this.$message({
                                        message: response.msg,
                                        type: 'warning'
                                    });
                                }
                            }).catch(err => {
                                this.$message.error('发生错误');
                            });
                        } else {
                            return false;
                        }
                    });
                },
            }
        }
</script>
<style scoped>
    .login {
        width: 1030px;
        margin: 0 auto;
    }

    .welcome-text {
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        padding-top: 20px;
        padding-bottom: 2%;
    }

    .login-form {
        /* background-color: #efefef; */
        padding: 0px 100px 20px 15px;
        border-radius: 10px;
        width: 400px;
        margin: 0 auto;
        text-align: center;
    }

    .btn {
        height: 28px;
        line-height: 28px;
        color: white;
        border: 0;
        background-color: #A7231E;
        font-weight: bold;
        padding: 5px 10px;
        margin: 0 10px;
    }

    .btn:hover {
        cursor: pointer;
        background-color: rgb(207, 50, 44);
    }
    .lod {
        display: inline-block;
        width: 28px;
    }
</style>